// Mock data for Shippzy courier services

export const services = [
  {
    id: 1,
    title: "International Shipping",
    description: "Worldwide door-to-door parcel delivery",
    features: ["Ship to 185+ countries", "Major carriers (DHL, FedEx, UPS)", "Customs clearance", "Real-time tracking"],
    icon: "globe",
    color: "bg-red-50 text-red-600",
    link: "#services"
  },
  {
    id: 2,
    title: "International Relocation",
    description: "Bulk shipping for personal belongings",
    features: ["India airport-to-airport from $7.99/kg", "Minimum 100 kg", "Doorstep delivery options available", "Free packaging for in-store bookings"],
    icon: "plane",
    color: "bg-yellow-50 text-yellow-600",
    link: "/relocation"
  },
  {
    id: 3,
    title: "Supplements & Protein Shipping",
    description: "Ship fitness supplements & nutrition globally",
    features: ["Protein powders & supplements", "Eligibility review process", "Customs support", "India & worldwide delivery"],
    icon: "package",
    color: "bg-red-50 text-red-600",
    link: "/shipping-supplements-protein"
  },
  {
    id: 4,
    title: "Electronics & Battery Shipping",
    description: "International electronics with battery compliance",
    features: ["Smartphones, laptops, tablets", "Lithium battery handling", "Carrier compliance", "Worldwide destinations"],
    icon: "smartphone",
    color: "bg-blue-50 text-blue-600",
    link: "/electronics-battery-shipping"
  },
  {
    id: 7,
    title: "International Perfume Shipping",
    description: "Luxury fragrance shipping with dangerous goods compliance",
    features: ["Alcohol-based perfumes", "Carrier approval process", "Specialized packaging", "Eligibility review"],
    icon: "package",
    color: "bg-amber-50 text-amber-600",
    link: "/international-perfume-shipping"
  },
  {
    id: 8,
    title: "International Barrel Shipping",
    description: "Cost-effective barrel shipping to Africa & Caribbean",
    features: ["Household goods", "Personal belongings", "Africa & Caribbean", "Large capacity shipping"],
    icon: "package",
    color: "bg-orange-50 text-orange-600",
    link: "/international-barrel-shipping"
  },
  {
    id: 5,
    title: "Discounted Rates",
    description: "UPTO 75% off on international shipping",
    features: ["Compare multiple carriers", "Best price guarantee", "No hidden fees", "Instant quotes"],
    icon: "tag",
    color: "bg-gray-50 text-gray-700",
    link: "#pricing"
  },
  {
    id: 6,
    title: "Locations & Drop-Off Services",
    description: "Visit our Brampton headquarters or contact our regional teams to arrange shipping, pickups, and available drop-off options across Canada.",
    features: ["Brampton Headquarters", "British Columbia & Nova Scotia Support", "Pickup & Drop-Off Assistance", "Shipping Services Across Canada"],
    icon: "map-pin",
    color: "bg-gray-50 text-gray-700",
    link: "/drop-off-locations"
  }
];

export const features = [
  {
    id: 1,
    title: "Real-Time Tracking",
    description: "Track your shipments 24/7 with our advanced tracking system",
    icon: "map-pin"
  },
  {
    id: 2,
    title: "Secure & Safe",
    description: "Your packages are insured and handled with utmost care",
    icon: "shield-check"
  },
  {
    id: 3,
    title: "Fast Delivery",
    description: "Quick and reliable delivery to destinations worldwide",
    icon: "clock"
  },
  {
    id: 4,
    title: "24/7 Support",
    description: "Our customer service team is always ready to help you",
    icon: "headphones"
  },
  {
    id: 5,
    title: "Affordable Rates",
    description: "Competitive pricing for all your shipping needs",
    icon: "dollar-sign"
  },
  {
    id: 6,
    title: "Easy Booking",
    description: "Simple online booking process in just a few clicks",
    icon: "mouse-pointer-click"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Kumar",
    company: "Sending to India",
    rating: 5,
    text: "Saved 50% on my shipment to India! Shippzy compared all carriers and got me the best rate. Highly recommend!",
    avatar: "RK"
  },
  {
    id: 2,
    name: "Priya Sharma",
    company: "International Student",
    rating: 5,
    text: "Used Shippzy for my relocation shipment from Canada to UK. Professional service and great prices!",
    avatar: "PS"
  },
  {
    id: 3,
    name: "David Thompson",
    company: "Small Business Owner",
    rating: 5,
    text: "The drop-off locations are so convenient! No need to wait for pickup. Fast and reliable service.",
    avatar: "DT"
  }
];

export const trackingHistory = [
  {
    status: "Delivered",
    location: "Toronto, ON",
    date: "2025-03-05",
    time: "14:30",
    description: "Package delivered successfully"
  },
  {
    status: "Out for Delivery",
    location: "Toronto, ON",
    date: "2025-03-05",
    time: "09:15",
    description: "Package is out for delivery"
  },
  {
    status: "In Transit",
    location: "Mississauga, ON",
    date: "2025-03-04",
    time: "18:45",
    description: "Package in transit to destination"
  },
  {
    status: "Picked Up",
    location: "Vancouver, BC",
    date: "2025-03-03",
    time: "10:00",
    description: "Package picked up from sender"
  }
];

export const pricingPlans = [
  {
    id: 1,
    name: "Economy",
    price: "Starting at $8.99",
    description: "Best for non-urgent shipments",
    features: [
      "5-7 business days delivery",
      "Basic tracking",
      "Up to 25kg",
      "Standard packaging"
    ],
    popular: false
  },
  {
    id: 2,
    name: "Standard",
    price: "Starting at $15.99",
    description: "Most popular choice",
    features: [
      "3-5 business days delivery",
      "Real-time tracking",
      "Up to 50kg",
      "Email notifications",
      "Secure handling"
    ],
    popular: true
  },
  {
    id: 3,
    name: "Express",
    price: "Starting at $29.99",
    description: "For urgent deliveries",
    features: [
      "24-48 hours delivery",
      "Priority tracking",
      "Up to 100kg",
      "SMS & email alerts",
      "Signature required",
      "Priority handling"
    ],
    popular: false
  }
];

export const locations = [
  {
    city: "Brampton (Head Office)",
    address: "140 Advance Blvd, Unit 7, Brampton, ON L6T 4Z8",
    phone: "+1 (437) 616-0758",
    email: "ship@shippzy.ca"
  },
  {
    city: "Surrey, BC",
    address: "Surrey, British Columbia",
    phone: "+1 (672) 699-6502",
    email: "shipwithshippzy<span class='text-yellow-500'>BC</span>@gmail.com",
    emailPlain: "shipwithshippzybc@gmail.com"
  },
  {
    city: "Nova Scotia",
    address: "Nova Scotia, Canada",
    phone: "+1 (902) 449-0682",
    email: "shipwithshippzy<span class='text-yellow-500'>NS</span>@gmail.com",
    emailPlain: "shipwithshippzyns@gmail.com"
  }
];

export const socialLinks = [
  { name: 'Facebook', url: 'https://www.facebook.com/profile.php?id=100090172262996&mibextid=LQQJ4d', icon: 'facebook' },
  { name: 'Instagram', url: 'https://instagram.com/shippzycouriers?igshid=YmMyMTA2M2Y=', icon: 'instagram' },
  { name: 'TikTok', url: 'https://www.tiktok.com/@shippzycouriers?_r=1&_t=zs-94si6mazl6l', icon: 'tiktok' },
  { name: 'LinkedIn', url: 'https://www.linkedin.com/company/shippzy/', icon: 'linkedin' },
  { name: 'YouTube', url: 'https://youtube.com/@shippzycouriers?si=8LciIaaIDdOqxwDN', icon: 'youtube' },
  { name: 'WhatsApp', url: 'https://wa.me/c/16479390758', icon: 'whatsapp' }
];